import React from 'react';
import './Stainless.css';

// Sample image imports — इन्हें अपनी actual image files से बदलें
import img1 from '../../../imgs/Stainlesssteel.webp';
import img2 from '../../../imgs/Selflubrication.webp';
import img3 from '../../../imgs/Synchronousejection.webp';
import img4 from '../../../imgs/Togglerecycling.webp';
import img5 from '../../../imgs/Closedinjection.webp';
import img6 from '../../../imgs/comparservo.webp';


const features = [
  {
    title: "Stainless Steel Separates",
    description: "Separates the area from conveyor to avoid contamination for products.",
    image: img1,
  },
  {
    title: "Self-Lubrication System",
    description: "With new material made sliding feet, which can prevent the contamination from lubricating oil.",
    image: img2,
  },
  {
    title: "Synchronous Ejection",
    description: "Mold opening and ejecting synchronously, lower cycle time and improves the manufacturing efficiency.",
    image: img3,
  },
  {
    title: "Toggle Recycling Lubrication System",
    description: "Reduces the contamination of the lubricating oil and keeps the clamping platform clean.",
    image: img4,
  },
  {
    title: "Closed Injection System",
    description: "Closed design with positive pressure laminar air flow device for finished products to keep this area clean.",
    image: img5,
  },
  {
    title: "Servo Motor System",
    description: "Saves more than 50% of the power, especially during pressure hold & cooling stage.",
    image: img6,
  },
];

const Stainless = () => {
  return (
    <div className="Stainles-wrapper">
      <h2 className="Stainles-heading">FEATURES</h2>

      <div className="Stainles-row">
        {features.slice(0, 3).map((item, index) => (
          <div className="Stainle-card" key={index}data-aos="fade-down">
            <img src={item.image} alt={item.title} className="Stainle-img" />
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>

      <div className="Stainles-row">
        {features.slice(3, 6).map((item, index) => (
          <div className="Stainle-card" data-aos="fade-down" key={index + 3}>
            <img src={item.image} alt={item.title} className="Stainle-img" />
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stainless;
